// extracted by mini-css-extract-plugin
export default {"scroll-button":"Vx8Iy","scroll-button__button":"eAnUK","scroll-button__button_withoutBadge":"oMTJj","scroll-button__badge":"jficr","scroll-button__action-button":"ro8Tc"};